export default __webpack_public_path__ + "media/images/77-581caa66697bc9907da44205b30b9f71.jpg";